import {
    GET_REWARDS_SETTINGS,
    GET_REWARDS_SETTINGS_SUCCESS,
    GET_REWARDS_SETTINGS_FAILURE,
    TOGGLE_REWARDS_SETTING,
    TOGGLE_REWARDS_SETTING_SUCCESS,
    TOGGLE_REWARDS_SETTING_FAILURE,
    GET_REWARDS_CONFIG,
    GET_REWARDS_CONFIG_SUCCESS,
    GET_REWARDS_CONFIG_FAILURE,
    UPDATE_REFERRAL_CONFIG,
    UPDATE_REFERRAL_CONFIG_SUCCESS,
    UPDATE_REFERRAL_CONFIG_FAILURE,
    UPDATE_FIRST_PURCHASE_CONFIG,
    UPDATE_FIRST_PURCHASE_CONFIG_SUCCESS,
    UPDATE_FIRST_PURCHASE_CONFIG_FAILURE,
    GET_DAILY_REWARDS,
    GET_DAILY_REWARDS_SUCCESS,
    GET_DAILY_REWARDS_FAILURE,
    UPDATE_DAILY_REWARDS,
    UPDATE_DAILY_REWARDS_SUCCESS,
    UPDATE_DAILY_REWARDS_FAILURE,
    GET_FREE_PLAY_CONFIG,
    GET_FREE_PLAY_CONFIG_SUCCESS,
    GET_FREE_PLAY_CONFIG_FAILURE,
    UPDATE_FREE_PLAY_CONFIG,
    UPDATE_FREE_PLAY_CONFIG_SUCCESS,
    UPDATE_FREE_PLAY_CONFIG_FAILURE,
} from "../constants";

const initialState = {
    isLoading: false,
    settings: [],       // array from GET /admin/settings
    settingsConfig: {}, // object from GET /admin/settings/config?key=...
    dailyRewards: [],   // array from GET /admin/daily-rewards
    freePlayConfig: {}, // object from GET /admin/game/free-play-config
};

export default function RewardsReducer(state = initialState, action) {
    switch (action.type) {

        // ── Settings list ────────────────────────────────────────────────────
        case GET_REWARDS_SETTINGS:
            return { ...state, isLoading: true };
        case GET_REWARDS_SETTINGS_SUCCESS:
            return { ...state, isLoading: false, settings: action.payload };
        case GET_REWARDS_SETTINGS_FAILURE:
            return { ...state, isLoading: false };

        // ── Toggle ───────────────────────────────────────────────────────────
        case TOGGLE_REWARDS_SETTING:
            return { ...state, isLoading: true };
        case TOGGLE_REWARDS_SETTING_SUCCESS:
            return { ...state, isLoading: false };
        case TOGGLE_REWARDS_SETTING_FAILURE:
            return { ...state, isLoading: false };

        // ── Per-tab config ───────────────────────────────────────────────────
        case GET_REWARDS_CONFIG:
            return { ...state, isLoading: true, settingsConfig: {} };
        case GET_REWARDS_CONFIG_SUCCESS:
            return { ...state, isLoading: false, settingsConfig: action.payload };
        case GET_REWARDS_CONFIG_FAILURE:
            return { ...state, isLoading: false };

        // ── Update referral config ────────────────────────────────────────────
        case UPDATE_REFERRAL_CONFIG:
            return { ...state, isLoading: true };
        case UPDATE_REFERRAL_CONFIG_SUCCESS:
            return { ...state, isLoading: false };
        case UPDATE_REFERRAL_CONFIG_FAILURE:
            return { ...state, isLoading: false };

        // ── Update first purchase config ──────────────────────────────────────
        case UPDATE_FIRST_PURCHASE_CONFIG:
            return { ...state, isLoading: true };
        case UPDATE_FIRST_PURCHASE_CONFIG_SUCCESS:
            return { ...state, isLoading: false };
        case UPDATE_FIRST_PURCHASE_CONFIG_FAILURE:
            return { ...state, isLoading: false };

        // ── Daily rewards ─────────────────────────────────────────────────────
        case GET_DAILY_REWARDS:
            return { ...state, isLoading: true };
        case GET_DAILY_REWARDS_SUCCESS:
            return { ...state, isLoading: false, dailyRewards: action.payload };
        case GET_DAILY_REWARDS_FAILURE:
            return { ...state, isLoading: false };

        case UPDATE_DAILY_REWARDS:
            return { ...state, isLoading: true };
        case UPDATE_DAILY_REWARDS_SUCCESS:
            return { ...state, isLoading: false };
        case UPDATE_DAILY_REWARDS_FAILURE:
            return { ...state, isLoading: false };
            
        // ── Free play config ──────────────────────────────────────────────────
        case GET_FREE_PLAY_CONFIG:
            return { ...state, isLoading: true, freePlayConfig: {} };
        case GET_FREE_PLAY_CONFIG_SUCCESS:
            return { ...state, isLoading: false, freePlayConfig: action.payload };
        case GET_FREE_PLAY_CONFIG_FAILURE:
            return { ...state, isLoading: false };

        case UPDATE_FREE_PLAY_CONFIG:
            return { ...state, isLoading: true };
        case UPDATE_FREE_PLAY_CONFIG_SUCCESS:
            return { ...state, isLoading: false };
        case UPDATE_FREE_PLAY_CONFIG_FAILURE:
            return { ...state, isLoading: false };

        default:
            return state;
    }
}

